module.exports = __webpack_public_path__ + "img/jobPositionIcon.cc344450.png";